<template>
	<div id="search">
		<myhead></myhead>
		<div class="bar">
      <router-link to="/">Fountain-Scientific official website</router-link>
      <span>></span>
      <span>Search key <span class="search-content">
				{{searchVal}}</span> result：</span>
			</span>
    </div>
		<div class="result" v-if="!loading">
			<div class="content">
				<div class="search-nav" v-show="items.length">
					<div class="type">
						<div class="nav-cls">Classification</div>
						<ul class="nav-ul">
							<li class="nav-name" v-for="(type,index) in types" :key="index"
							@click="byNameAndBrandOrType('',type)">
								{{type}}
							</li>
						</ul>
					</div>
					<div class="brand">
						<div class="nav-cls">Brands</div>
						<ul class="nav-ul">
							<li class="nav-name" @click="byNameAndBrandOrType('all','')">All</li>
							<li class="nav-name" v-for="(brand,index) in brands" :key="index"
							@click="byNameAndBrandOrType(brand,'')">
								{{brand}}
							</li>
						</ul>
					</div>
					<div class="brand shape" v-show="shapes.length">
						<div class="nav-cls">Shape</div>
						<ul class="nav-ul">
							<li class="nav-name" @click="byNameAndBrandOrType('','','all')">All</li>
							<li class="nav-name" v-for="(shape,index) in shapes" :key="index"
							@click="byNameAndBrandOrType('','',shape)">
								{{shape}}
							</li>
						</ul>
					</div>
					<div class="brand capacity" v-show="capacitys.length">
						<div class="nav-cls">Capacity</div>
						<ul class="nav-ul">
							<li class="nav-name" @click="byNameAndBrandOrType('','','','all')">All</li>
							<li class="nav-name" v-for="(capacity,index) in capacitys" :key="index"
							@click="byNameAndBrandOrType('','','',capacity)">
								{{capacity}}
							</li>
						</ul>
					</div>
					<div class="brand category" v-show="categorys.length">
						<div class="nav-cls">Category</div>
						<ul class="nav-ul">
							<li class="nav-name" @click="byNameAndBrandOrType('','','','','all')">All</li>
							<li class="nav-name" v-for="(category,index) in categorys" :key="index"
							@click="byNameAndBrandOrType('','','','',category)">
								{{category}}
							</li>
						</ul>
					</div>
				</div>
				<div class="null" v-show="!items.length">
					Sorry, nothing to find
				</div>
				<div class="items-box" v-show="items.length">
					<div class="item" v-for="(item,index) in items" :key="index"
					@click="detail(item.id)">
						<img :src="isHaveImg(item.picture||item.img)" class="item-img">
						<p class="item-name">{{item.name}}</p>
						<!-- <p class="price">￥ <span>{{item.price || 6}} </span> 起</p> -->
					</div>
				</div>
				<div class="btn-box" v-show="maxPage > 1">
					<ul class="btn-ul">
						<li class="btn-n" @click="toPage(1)" v-show="curPage != 1">
							 &lt;&lt;
						</li>
						<li class="btn-n" v-for="n in maxPage" :key="n"
						:class="curPage == n? 'btn-active':''" @click="toPage(n)">
							{{n}}
						</li>
						<li class="btn-n" @click="toPage(maxPage)"
						v-show="curPage != maxPage">
							&gt;&gt;
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import myhead from "./common/header.vue";
import axios from "axios";
const url = require("../url").url
export default {
	name:'Search',
	components: {
    myhead
	},
	created(){
		this.init()
	},
  data() {
    return {
			loading:true,
			byName:{},
			curPage:0,
			items:[],
			maxPage:0,
			byType:{},
			//nav上的品牌和分类
			brands:[],
			types:[],
			capacitys:[],
			categorys:[],
			shapes:[],

			searchVal: '',
			select:'',
    };
	},
	watch: {
    // 如果路由有变化，会再次执行该方法
    '$route'(){
			this.init()
		}
  },
  methods: {
		toPage(n){
			this.$router.push({ path: 'search',query:{
				keyword:this.searchVal,
				page:n,
				select:window.localStorage.select||''
			}})
		},
		searchByName(){
			let self = this
			this.$ajax({
				url: 'https://fountain-scientific.com/v2/search?keyword='+self.$route.query.keyword+'&select='+self.$route.query.select+'&page='+self.$route.query.page,
				type: "GET",
				data: "{}",
				success: function(data) {
					self.maxPage=data.data.totalpage
					self.searchVal = self.$route.query.keyword
					self.items = data.data.item
					if(data.data.length == 0 || data.data.item.length == 0){
						self.items=[]
					}
					if(data.data!=''&&data.data.meta.length!=0){
						self.types = data.data.meta.content.分类
						self.brands = data.data.meta.content.品牌
					}
					self.loading = false
				},
				error: function(error) {
					console.log(error)
				}
			});
		},
		init(){
				this.searchByName();
		},
		byNameAndBrandOrType(brand,type,shape,capacity,category){

			if(!window.localStorage){
					alert("localstorage failed");
					return false;
			}else{
					if(!window.localStorage.oneBrand||window.localStorage.oneBrand==''||((window.localStorage.oneBrand!=brand)&&(brand!='')))
							window.localStorage.setItem("oneBrand",brand);
					if(!window.localStorage.oneType||window.localStorage.oneType==''||((window.localStorage.oneType!=type)&&(type!='')))
							window.localStorage.setItem("oneType",type);
			}
			if (brand === 'all') {
				window.localStorage.oneBrand = ''
				brand = null
			}
			window.localStorage.setItem("select",window.localStorage.oneBrand+' '+window.localStorage.oneType);

			this.$router.push({ path: 'search',query:{
					keyword:this.searchVal,
					select:window.localStorage.select,
					page:1
				}
			})
			let self = this
			this.$ajax({
				url: 'https://fountain-scientific.com/v2/search?keyword='+self.$route.query.keyword+'&select='+self.$route.query.select+'&page=1',
				type: "GET",
				data: "{}",
				success(data){
					self.items = data.data.item
					if(data.data.length == 0 || data.data.item.length == 0){
						self.items=[]
					}
				}
			})
		},

		/*判断商品是否有图片,有的返回[0],没有返回默认
		https://p810g4fh2.bkt.clouddn.com/image/noPhoto.jpg*/
		isHaveImg(v){
			if(typeof(v)=="object"){
				if(v.length!=0) return v[0]
				else return 'https://p810g4fh2.bkt.clouddn.com/image/noPhoto.jpg'
			}else if(typeof(v)=="string"){
				return v
			}

		},
		detail(id){
			this.$router.push({ path: 'detail',query:{
				id
			}})
		}
	},
};
</script>
<style lang="less" scoped>
@import url("../assets/css/style.less");

.bar{
  height: 30px;
  line-height: 30px;
  text-align: left;
  font-size: 14px;
  padding: 0 10%;
  margin: 20px 0;
}
.bar>span{
  margin: 0 10px;
}
.search-content{
	font-weight: 600;
	font-size: 18px;
}
.t-red{
	color: @indexTheme;
}
.content{
	padding: 0 10%;
}
.items-box{
	display: flex;
	flex-wrap: wrap;
	padding-bottom: 30px;
	margin-bottom: 40px;
	/* justify-content: space-around; */
	border-bottom: 1px #bdbdbd dotted;
}
.item{
	width: 18%;
	text-align: center;
	font-size: 14px;
	margin-right: 20px;
	margin-bottom: 30px;
}
.item:hover{
	color: @indexTheme;
}
.item-img{
	width: 140px;
	height: 140px;
	display: inline-block;
}
.item-name{
	font-size: 12px;
	margin: 7px 0;
}
.price{
	color: #aea49b;
}
.price>span{
	font-size: 18px;
	font-weight: 600;
	color: @indexTheme;
}
.search-nav{
	margin-bottom: 30px;
	border-top: 1px #ddd solid;
}
.type,.brand{
	display: flex;
	border: 1px #ddd solid;
	border-top: 0;
}
.nav-cls{
	color: #222;
	font-size: 16px;
	min-width: 120px;
	background-color: rgb(241, 241, 241);
	border-left: 1px #ddd solid;
	display: flex;
	align-items: center;
	padding-left: 20px;
}
.nav-ul{
	display: flex;
	flex-wrap: wrap;
	font-size: 14px;
	padding: 10px 20px;
	align-items: center;
}
.nav-ul>li{
	margin: 5px 15px;
	height: 20px;
	line-height: 20px;
}
.nav-name{
	margin-top: 5px;
}
.nav-name:hover{
	text-decoration: underline;
}
.null{
	margin-bottom: 50px;
}
.btn-ul{
	display: flex;
	justify-content: center;
}
.btn-n{
	line-height: 30px;
	margin: 0 5px;
	width: 30px;
	height: 30px;
	text-align: center;
	border: #ccc 1px solid;
	color: #666;
}
.btn-active{
	background-color: #ccc;
	font-weight: 600;
}
.btn-n:hover{
	background-color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/search.vue